// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__3wjdr","LoaderCentered":"Loader_LoaderCentered__1R1WU"};